import { Link, Navigate, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLanguage, tr } from "../i18n";
import { lp } from "../components/Navbar";
import { Reveal, Kicker } from "../components/motion";
import { CTABand } from "./Shared";
import { articles } from "../data/articles";
export default function Article() {
  const {
    slug
  } = useParams();
  const {
    lang
  } = useLanguage();
  const article = articles.find(a => a.slug === slug);
  if (!article) return <Navigate to={lp(lang, "/insights")} replace />;
  return <div data-testid="article-page">
      <article className="mx-auto max-w-3xl px-4 py-16 sm:px-6 sm:py-20 lg:px-8">
        <Reveal y={12}>
          <Link to={lp(lang, "/insights")} data-testid="article-back-link" className="group inline-flex items-center gap-2 text-xs font-semibold text-esaia-blue">
            <ArrowLeft size={14} className="transition-transform group-hover:-translate-x-1" />{tr("Back to Insights")}{" "}</Link>
        </Reveal>
        <Reveal delay={0.1} className="mt-8">
          <div className="flex flex-wrap items-center gap-3 font-mono text-[10px] uppercase tracking-[0.2em] text-esaia-subtle">
            <span className="text-esaia-blue">{tr(article.category)}</span>
            <span>{article.date}</span>
            <span>{tr(article.readTime)}</span>
          </div>
          <h1 className="mt-5 text-3xl font-semibold leading-tight tracking-tight text-esaia-ink sm:text-4xl" data-testid="article-title">
            {tr(article.title)}
          </h1>
          <p className="mt-4 text-sm text-esaia-subtle">{tr("By")}{" "}{tr(article.author)}</p>
        </Reveal>

        <Reveal delay={0.2} className="mt-8 border-y border-esaia-line py-6">
          <p className="font-serif text-xl font-light leading-relaxed text-esaia-ink">{tr(article.excerpt)}</p>
        </Reveal>

        <div className="mt-10 space-y-10">
          {article.content.map((section, i) => <Reveal key={i} delay={0.05 * i}>
              <section>
                {section.heading && <h2 className="text-xl font-semibold text-esaia-ink sm:text-2xl">{section.heading}</h2>}
                {section.paragraphs.map((p, j) => <p key={j} className="mt-4 text-base leading-relaxed text-esaia-muted">
                    {p}
                  </p>)}
              </section>
            </Reveal>)}
        </div>

        <Reveal className="mt-12 border-t border-esaia-line pt-6">
          <Kicker>{tr("ESAIA Standards Secretariat")}</Kicker>
          <p className="mt-3 text-xs leading-relaxed text-esaia-subtle">{tr("ESAIA Insights provides general analysis. It does not constitute legal advice, and ESAIA certification should not be interpreted as a declaration of legal compliance with the EU AI Act or any other legislation.")}{" "}</p>
        </Reveal>
      </article>

      <CTABand title={tr("Put these ideas into practice.")} copy={tr("Start with the free ERI to understand where your organization stands, or request a full ESAIA assessment.")} primary={{
      to: "/eri",
      label: tr("Take the Free ERI")
    }} secondary={{
      to: "/contact",
      label: tr("Request a Quote")
    }} />
    </div>;
}
